import { render, staticRenderFns } from "./SalesConfig.vue?vue&type=template&id=567bd00c&"
import script from "./SalesConfig.vue?vue&type=script&lang=js&"
export * from "./SalesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports